import { render, staticRenderFns } from "./acreditaciones.vue?vue&type=template&id=63e4ae3c&"
import script from "./acreditaciones.component.ts?vue&type=script&lang=ts&"
export * from "./acreditaciones.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports